import { createReducer } from '@ngrx/store';

import { produceOn } from 'app/_state/produce-on';

import * as ACTIONS from './auth-actions';
import { initialState } from './auth-state';

const _authReducers = createReducer(initialState,
  produceOn(ACTIONS.setCurrentUser, (state, props) => {
    state.current_user = props.payload as any;
  }),
  produceOn(ACTIONS.clearCurrentUser, (state, _) => {
    state.current_user = null;
  }),
  produceOn(ACTIONS.setPasswordResetMessage, (state, props) => {
    state.password_reset_message = props.message;
  }),
  produceOn(ACTIONS.clearPasswordResetMessage, (state, props) => {
    state.password_reset_message = null;
  }),
);

export function authReducers(state, action) {
  return _authReducers(state, action);
}
